import { createGlobalStyle } from "styled-components";
import { palette, font } from "styled-theme";
import bgImage from "@iso/assets/images/graph.png";
import dashboardHeader from "@iso/assets/images/member-dashboard-header-bg.png";
import DetailsbgImage from "@iso/assets/images/notification-bg.png";
// import 'antd/dist/antd.css';

const GlobalStyles = createGlobalStyle`
.ranking-badge {
  font-weight: bold;
  padding: 5px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 28px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  border: 2px solid #ffffff;
  color: #ffffff;
  font-size: 15px;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
}

.ranking-badge::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100px;
  width: 200%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  transform: skewX(-45deg);
  animation: shine 4s infinite linear;
  animation-direction: normal;
}

.ranking-v0 {
  background: linear-gradient(45deg, #CCCCCC, #B3B3B3); /* Deeper Grey Gradient for Starter */
  color: #FFFFFF;
}

.ranking-v1 {
  background: linear-gradient(45deg, #D19BB4, #C089A4); /* Deeper Pink Gradient for 1st Rank */
  color: #FFFFFF;
}

.ranking-v2 {
  background: linear-gradient(45deg, #D95A77, #C34A63); /* Deep Pink Gradient for 2nd Rank */
  color: #FFFFFF;
}

.ranking-v3 {
  background: linear-gradient(45deg, #AC82C1, #9670AC); /* Lavender Gradient for 3rd Rank */
  color: #FFFFFF;
}

.ranking-v4 {
  background: linear-gradient(45deg, #7798BF, #5E85AF); /* Light Blue Gradient for 4th Rank */
  color: #FFFFFF;
}

.ranking-v5 {
  background: linear-gradient(45deg, #90B57D, #78A068); /* Green Gradient for 5th Rank */
  color: #FFFFFF;
}

.ranking-v6 {
  background: linear-gradient(45deg, #D49663, #C38354); /* Peach Gradient for 6th Rank */
  color: #FFFFFF;
}

.ranking-v7 {
  background: linear-gradient(45deg, #B89D7A, #A18767); /* Beige Gradient for 7th Rank */
  color: #FFFFFF;
}

.ranking-v8 {
  background: linear-gradient(45deg, #D6CB72, #BBAF60); /* Deep Yellow Gradient for Highest Rank */
  color: #FFFFFF;
}



@keyframes shine {
  0% {
    left: -100px;
  }
  100% {
    left: 100%;
  }
}

.firstplace-frame{
  width: fit-content;
    padding: 10px;
    background: #ffc70047;
    border-radius: 50%;
    text-align: center;
}
.secondplace-frame{
  width: fit-content;
    padding: 10px;
    background: #a4a4a42e;
    border-radius: 50%;
    text-align: center;
}
.thirdplace-frame{
  width: fit-content;
    padding: 10px;
    background: #ff8b0021;
    border-radius: 50%;
    text-align: center;
}
.custom-carousel{
  .ellipsis-title{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .slick-list{
    height:38px!important;
  }
  .slick-slide{
    height:38px !important
  }
}
.custom-badge{
  .ant-scroll-number-custom-component{
    margin-top:85%;
    right:5px !important;
    // background: gold;
    color: white;
    padding: 6px;
    border-radius: 10px;
  }
}
.custom-form-label .ant-form-item-label > label{
font-weight:bold
}
.text-ellipsis{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-wrapper{
  display:flex;
  justify-content:space-between;
  padding:12px;
  background-color:white;
  margin-top:5px;
  align-items:center
}
.summary-wrapper:active{
  background-color:#F5F5F5
}
.summary-wrapper:hover{
  cursor:pointer
}
.custom-dashboard-header{
  background: url(${dashboardHeader}) no-repeat;
  background-position:center;
  background-size:cover;
}
.BinaryHintModal{
  width:80%!important ;
  max-width:380px;
  .ant-modal-footer button:first-child {
display:none
  }
  .ant-modal-footer button:nth-child(2){
    width:100%;
    margin-left:0px!important
      }
  .ant-modal-content{
    border-radius:8px !important
  }
  .ant-modal-title{
    font-weight:bold!important;
    font-size:13px!important;
  }
  .ant-modal-header{
    padding:10px 16px;
    border-bottom:none!important;
    border-radius:12px;
    text-align:center
  }
  .ant-modal-body{
    height: 220px;
    vertical-align: middle;
    align-content: center;
    align-items: center;
    align-self: center;
    display: grid;
  }
}
.swal2-title{
  text-transform:capitalize!important;
  font-size:1.25em;
}
.swal2-styled.swal2-confirm{
  background-color:#5680F9;
  color:#222;
  font-weight:bold;
  min-width:100px
}
.swal2-styled.swal2-confirm:focus{
  box-shadow:none
}
.maxWidth90{
  max-width:90%;
  margin:auto;
}
.content-vertical-center{
  display:flex;
  align-items:center;
  font-size:1.05em;
  svg{
    width:30px !important;
    fill:#5680F9;
    padding-right:8px;
  }
}
.profile-icons {
  // border: 2px solid #5680f98c;
  // padding: 6px;
  // color: #5680F9;
  // border-radius: 6px;
  // font-size: 30px;
width: 55px;
height: 55px;
text-align: center;
margin: auto;
margin-bottom: 0px;
}
.not-function{
  -webkit-filter: grayscale(1);
background-color:#f1f1f1;
opacity: 0.5;
}
.announcement-content{
  padding-top:12px;
  font-size:0.85em;
  color:grey
}
.details-content{
  display: -webkit-box;
    /* max-width: 400px; */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#b6b4b4;
    height:38px;
}
.king-tabs{
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: white;
    text-shadow: 0 0 0.25px currentcolor;
    background: #5680F9;
    padding: 10px 20px;
    border-radius: 8px;
  }
  .ant-tabs-tab .ant-tabs-tab-btn{
    padding: 10px 20px;
    text-align:center;
    font-weight:bold;
    color:grey
  }
  .ant-tabs-ink-bar{
    background: #5680F9;
  }
}
.value-left-frame{
  background: url(${bgImage}) no-repeat;
  height:138px;
  background-position-x:calc(100% - 15px);
  background-position-y: calc(100% + 25px);
  background-size: calc(100% - 70%);
  border-radius:6px;
  background-color:white;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  padding:15px 20px
}
.announcement-details-bg{
  // background: url(${DetailsbgImage}) no-repeat top left;
  padding:15px 20px;
}
.graphbg{
  height:100%;
}
.buy-sell-frame{
  background-color:#5680F9;
  padding:10px 15px;
  border-radius:6px;
  margin-bottom:15px;
  font-weight:bold;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
}
.value-frame{
  background-color:white;
  border-left:4px solid #5680F9;
  padding:8px 10px;
  border-top-right-radius:4px;
  border-bottom-right-radius:4px;
  margin-bottom:12px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
}
.assets-frame{
  background-color:white;
  width:100%;
  text-align:center;
  padding:13px 10px;
  border-radius:7px;
  margin-bottom:10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  svg{
    width:38px;
    margin-bottom:4px;
    fill:#5680F9
  }
}
.custom-slider{
  flex-flow:initial !important;
  overflow:auto;
  margin-bottom:12px
}

.custom-slider {
  scrollbar-width: auto;
  scrollbar-color: #5680F9 #ffffff;
}

/* Chrome, Edge, and Safari */
.custom-slider::-webkit-scrollbar {
  width: 16px;
}

.custom-slider::-webkit-scrollbar-track {
  background: #F7F7F7;
  border-radius:10px;
  margin:0 10px
}

.custom-slider::-webkit-scrollbar-thumb {
  background-color: #5680F9;
  border-radius: 10px;
  border: 5px solid #F7F7F7;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
}
.ant-input-prefix{
  margin-right:8px;
  font-size:22px
}
body{
  width:533px;
  margin:auto 
}
.isoContentMainLayout{
  nav{
    width:516px
  }
}
@media only screen and (max-width: 768px){
  .custom-header{
    width:516px!important;
  }
  body{
    width:100%
  }
  .isoContentMainLayout{
    nav{
      width:100%
    }
  }
}
.custom-form{
  .ant-form-item{
    margin-bottom:12px;
  }
  .ant-input{
  
  }
}
.section-header{
  display:flex;
  align-items:center;
  vertical-align:middle;
  font-weight:bold;
  padding-top:7px;
  svg{
    width:16px;
    height:16px;
    margin-right:5px;
    fill:black;
  }
}
.dollar-icon{
  sup svg{
    width:14px;
    fill:#C8C8C8;
  }
}
.ant-carousel-vertical .slick-dots-left {
  visibility:hidden
}
.isoWidgetsWrapper{
  .ant-tabs-nav-wrap{
    display:block !important;
  }
  .ant-tabs-nav-list{
    justify-content:space-around!important
  }
}
.w-100{
  width:100%
}
.gt-button {
  margin:0px 10px;
  min-width:150px;
  margin-bottom:10px;
  margin-left:0px;
  border:1px solid #33335B;
  background:#494982;
  color:white
}
.ant-page-header {
  width: 100%; 
  padding: 0 0 30px 0!important;
}
.ant-page-header-heading-title{
  color:#33335b !important
}
.ant-page-header-heading-extra{
  margin:auto 0 !important;
  overflow:auto
}
.firstbreadcrumb{
  color: #000066;
    font-weight: 500;
}
.payment-button-mobile{
  display:flex;
  justify-content:center;
}
@media only screen and (max-width: 768px) {
  
  .payment-button-mobile{
    display:block;
    text-align:center;
    
  }
  .ant-input{
    width:100% !important
  }
  .ant-picker{
    width:auto !important
  }
  .ant-select{
    width:100% !important
  }
}
.ant-select-dropdown{
  width:auto !important
}
@media only screen and (max-width: 768px) {
  .desktop-only{
    display:none;
  }
  .hide-font{
    display:none !important
  }
}
.ant-table-container{
  overflow:auto;
}

.ant-card-hoverable:hover{
  box-shadow:none !important;
  border-color:#b114ff !important
}
  .ant-btn{
    border-radius: 4px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  body{
    overflow-y:auto
  }
  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  .ant-row.ant-form-item {
    // margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-family: 'Poppins';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }
  /*-----------------------------------------------*/
  // style Font size
  /*-----------------------------------------------*/
  .font-sm {
    font-size: 0.9em!important;
  }
  .font-lg {
    font-size: 1.1em!important;
  }
  .font-xl {
    font-size: 1.2em!important;
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 14px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }
  .custom-quantity-input{
    .ant-input[disabled]{
      color:black;
      font-weight:bold
    }
    background:white;
    border-radius:6px;
    border:none;
    padding:0;
    color:black
  }
  .ant-modal-wrap {
    .modalclass {
      .ant-modal-content {
        background-color: #fff;
        border-radius: 0px;
        p{
          // color: white;
          margin-top: 50px;
        }
      svg{
        color: black;
      }
        .ant-modal-footer{
          border-top: 0px;
        }
        // .ant-modal-header{
        //   background-color: #4C5292;
        //   border-bottom: 0px;
        //   border-radius: 10px;
        //   .ant-modal-title{
        //     color: white;
        //     margin-top: 30px;
        //     font-size: 25px;
        //   }
        // }
      }
    }
  }


/*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font("primary", 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette("primary", 0)};
    color: #fff;
  }
}

.ant-row:not(.ant-form-item) {
  ${
    "" /* margin-left: -8px;
  margin-right: -8px; */
  };
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;
  background: ${palette("secondary", 1)};
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  left: 0;
  margin-left: -4px;
}

/* Instagram Modal */

.ant-modal-wrap.instagram-modal .ant-modal {
  max-width: 935px;
  width: 100% !important;
}

@media only screen and (max-width: 991px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    padding: 0 60px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-page-header{
    padding:20px !important
  }
  .ant-modal-wrap.instagram-modal .ant-modal {
    max-width: 580px;
  }
}

.ant-modal-wrap.instagram-modal .ant-modal-content {
  border-radius: 0;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close {
  position: fixed;
  color: #fff;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close i {
  font-size: 24px;
}

.ant-modal-wrap.instagram-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}

/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}


.frame {
  width: 100%
}
@media only screen and (max-width: 767px) {
  .frame{
    width:auto
  }
}

.banner-padding{
  padding:25px;
}

.padding-responsive{
  padding:25px;
}

.padding-responsive-out{
  padding:20px 18px;
  margin:auto;
  max-width:90%;
}
@media (max-width: 767px) {
  .content-mobile{
    padding-bottom:25px;
  }
  .padding-responsive-out{
    max-width:100%;
  }
  .FormCss{
    padding:15px !important;
   
  }
  .banner-padding{
    padding:0px;
  }
  .padding-responsive{
    padding:15px;
  }
  
  .ant-spin-nested-loading > div > .ant-spin {
  position:fixed!important;
  top:0!important;
  left:0!important;
  z-index:4!important;
  display:block!important;
  width:100%!important;
  height:100%!important;
  max-height:100vh!important;    
  background: #ffffff91;
  z-index: 9999!important;
}
}

.time-css{
  color:#0073b7;
  border-radius:10px;
  padding:0.25em 1em;
  background-color:#E6EEF5;
  min-width: 130px;
}

.announcement-dashboard{
  border:1px solid #80808033;
  padding:15px !important;
  border-radius:15px;
  background:white;
  height:373px;
  overflow:auto;
}
.events-image{
  width:85%;
  height:85%;
  border-radius:25px
}
.events-desc{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .ql-editor {
    overflow: hidden;
  //  text-overflow: ellipsis;
    display: -webkit-box;
  -webkit-line-clamp: 2;
          // line-clamp: 2;
  -webkit-box-orient: vertical;
  }
}
.events-read{
  margin:auto;
  text-align:center;
  font-weight:500;
  color:#fff;
  background:black;
  border-radius:6px;
  padding:6px !important;
  font-size:0.8em
}
.events-title{
  font-weight:bold;
  color:#364D79;
}
.events-date-title{
  font-weight:500;
}
.events-date{
font-weight:500;
color: #DEAB5A;
}


/*-----------------------------------------------*/
  // style for table list
/*-----------------------------------------------*/
.ant-table {
  border:1px solid #e9e9e9
}
.tbTable {
  .ant-table-tbody > tr > td{
    padding:10px !important
  }
  .ant-select-selector{
    background-color: ${palette("primary", 0)};
    color: white;
    border-radius: 4px!important;  
  }
  width: 100%;
  .ant-select-arrow {
    color: white !important;
  }

  .ant-table-thead .ant-table-cell {
    background-color: #eaeaea;
  }
}
.table-row-light {
  background-color: #ffffff;
}
.table-row-dark {
  background-color: #eaeaea;
}

/*-----------------------------------------------*/
  // style for Card
/*-----------------------------------------------*/

.card-title{
  font-size:1.1em;
  font-weight:500;
  color:#d39024

}
.ant-select-single.ant-select-open .ant-select-selection-item{
  color:white
}
.text-height{
  color:#555;
  font-size:14px;
  letter-spacing:.3px;
  text-transform:uppercase;
  font-weight:500;
  overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
height:44px;
}
.product-desc{
  color:#999;
  font-weight:normal;
  font-size:13px;
  padding-top:6px;
  overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
line-height:normal
}
.announcement-card{
  .ql-editor{
    padding:0px
  }
  .ant-card-body{
    padding:20px 0px;
    margin-bottom: 30px;
    padding-bottom: 34px;
    border-bottom:3px dashed #E3E3E3
  }
}
.ant-table-thead > tr > th{
  padding:10px !Important
}
.navigation-bar-icon {
  path {
    fill: #5680F9
  }
}
.navigation-bar-icon-default{
  path{
    fill:#8c8c8c
  }
}
.selected-navigation {
  color: #5680F9
}
.selected-navigation-default {
  color: #8c8c8c
}
.ant-btn-primary{
  color: #000;
  font-weight:500;
    border-color: #5680F9 !important;
    background: #5680F9 !important;
}
.text-ellipsis{
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.adjust-error-message{
  .ant-form-item-control{
    flex:1 1 110px!important
  }
}
.ant-btn-primary span {
 color:white
}
.wallet-nav-header{
  height:auto;
  padding-top:23px;
  padding-bottom:18px;
  color:white;
  background:#616161;
}
.sa-wrapper{
  border:1px solid #c0c0c0;
  border-radius:4px;
  width:100%;
  max-width:400px;
  margin:auto;
  margin-top:15px;
  display:flex;

}
.sa-password-input{
  border-radius:4px;
  border:none;
  padding:7px;
  width:90%;
  padding-right:10px;
}
.sa-password-input:focus-visible{
  border:none !important;
  outline:none;
}
`;

export default GlobalStyles;
